import { deepMerge } from '@empathybroker/deep-merge';
import { Messages } from '../../../i18n';
import { ConfigState, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';
import { ConfigGetter } from '../config.interfaces';

export class MessagesGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.messages]: (configState: ConfigState, getters: any): Messages => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      const { messages, languagesFallbacks } = config.locale;
      const rawLanguage = configState.dynamic.lang;
      const { language, defaultLanguage } = this.getNormalizedLanguage(rawLanguage);
      const languageFallback = languagesFallbacks[language];
      return deepMerge({}, messages.en, messages[defaultLanguage], messages[languageFallback], messages[language]);
    }
  };

  /*
   * Normalizes the language to the <lang>_<COUNTRY> format, which is the one used to store the messages by default.
   * This allows the client to pass us the language in other formats which match their cores like <lang>-<COUNTRY>, with any casing.
   * This function also returns a defaultLanguage which will be used as 2nd fallback. For example:
   * If the client sets 'es-mx' as language, this function returns { defaultLanguage: 'es', language: 'es_MX' }.
   */
  private getNormalizedLanguage(language: string) {
    const languageParts = language.split(/[_-]/);
    const isLanguageWithCountry = languageParts.length === 2;
    return {
      defaultLanguage: isLanguageWithCountry ? languageParts[0] : undefined,
      language: isLanguageWithCountry ? `${ languageParts[0].toLowerCase() }_${ languageParts[1].toUpperCase() }` : languageParts[0]
    };
  }
}
